import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";

/**
* @class Company
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.companies[0];
* const account = new Company(record);
* @property {NUMBER} _id - The id of the company.
* @property {STRING} _name - The name of the company.
* @description Companies in the demo like "Presidents Inc.".
*/

export default class Company extends BCMSRecord {
  _id
  _name

  constructor(record) {
    super(record)
  }
}

Company.define({
  "recordType": "companies",
  "recordIDProp": "id",
  "className" : "Company",
  "recordProperties": [

   /** 
    * @name id
    * @instance
    * @property get {NUMBER} - gets the id 
    * @property set {NUMBER} - sets the id
    * @memberof Company 
    */

    BCMSRecordProperty.mapToString("id", "_id"),

    /** 
     * @name name
     * @instance
     * @property get {STRING} - gets the name
     * @property set {STRING} - sets the name
     * @memberof Company 
     */

    BCMSRecordProperty.mapToString("name", "_name"),

  ]
})




